<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode">
            <div id="titleArea">
                <div class="titleText">课程表</div>
                <div class="titleButton">
                    <el-button class="custom-el-button" type="primary" @click="showHomePage">
                        <i class="el-icon-s-home"></i> 首页
                    </el-button>
                </div>
            </div>
            <div id="queryArea">
                <div class="filter-container">
                    <div class="formItem">
                        <div style="display:inline-block;">
                            <el-select v-model="queryForm.semesterCode" placeholder="学年学期" style="width:60vw;" @change="handleSemesterChange">
                                <el-option v-for="(item, index) in comboOption.semester" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                </el-option>
                            </el-select>
                        </div>
                        <div style="display:inline-block;">
                            <el-select v-model="queryForm.weekNum" placeholder="周次" style="width:30vw;" @change="handleWeekChange" clearable>
                                <el-option v-for="(item, index) in comboOption.week" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
            </div>
            <div id="contentArea"
                v-loading="timetableLoading"
                element-loading-text="课表加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.6)">
                <table id="timetable" class="timetable" :style="{width: (32 * weekDayNum + 40) + 'vw'}">
                    <thead>
                        <tr>
                            <th class="timetableTitle separetor contentHide" colspan="3"></th>
                            <th class="timetableTitle separetor weekDayName contentHide" v-for="(item, index) in weekDayName"
                                v-html="item + (weekDayDate==null?'':('<br/>'+weekDayDate[index]))">
                            </th>
                        </tr>
                    </thead>
                    <tr v-if="forenoonNum > 0" :style="{height: timetableRowHeight + 'px'}">
                        <td class="timetableTitle separetor contentHide" :rowspan="forenoonNum" style="width:10vw;">上<br/><br/>午</td>
                        <td class="timetableTitle contentHide" style="width:10vw;">1</td>
                        <td class="timetableTitle contentHide" style="width:20vw;" v-html="timeQuantum[0]"></td>
                        <td v-for="m in weekDayNum"
                            class="timetableContent"
                            :id="'cell_' + (m-1)"
                            :name="'weekDayNum_' + m"
                            onclick="showDetailInfo(this.id)"></td>
                    </tr>
                    <template v-if="forenoonNum > 1">
                        <tr v-for="n in forenoonNum-1" :style="{height: timetableRowHeight + 'px'}">
                            <td :class="n < forenoonNum-1 ? 'timetableTitle contentHide' : 'timetableTitle separetor contentHide'">{{ n+1 }}</td>
                            <td :class="n < forenoonNum-1 ? 'timetableTitle contentHide' : 'timetableTitle separetor contentHide'"
                                v-html="timeQuantum[n]"></td>
                            <td :class="n < forenoonNum-1 ? '' : 'separetor'"
                                v-for="m in weekDayNum"
                                class="timetableContent"
                                :id="'cell_' + (n*weekDayNum + m-1)"
                                :name="'weekDayNum_' + m"
                                onclick="showDetailInfo(this.id)"></td>
                        </tr>
                    </template>
                    <tr v-if="noonNum > 0" :style="{height: timetableRowHeight + 'px'}">
                        <td class="timetableTitle separetor contentHide" :rowspan="noonNum">中<br/><br/>午</td>
                        <td class="timetableTitle contentHide">1</td>
                        <td class="timetableTitle contentHide" v-html="timeQuantum[forenoonNum]"></td>
                        <td v-for="m in weekDayNum"
                            class="timetableContent"
                            :id="'cell_' + (forenoonNum*weekDayNum + m-1)"
                            :name="'weekDayNum_' + m"
                            onclick="showDetailInfo(this.id)"></td>
                    </tr>
                    <template v-if="noonNum > 1">
                        <tr v-for="n in noonNum-1" :style="{height: timetableRowHeight + 'px'}">
                            <td :class="n < noonNum-1 ? 'timetableTitle contentHide' : 'timetableTitle separetor contentHide'">{{ n+1 }}</td>
                            <td :class="n < noonNum-1 ? 'timetableTitle contentHide' : 'timetableTitle separetor contentHide'"
                                v-html="timeQuantum[forenoonNum+n]"></td>
                            <td :class="n < noonNum-1 ? '' : 'separetor'"
                                v-for="m in weekDayNum"
                                class="timetableContent"
                                :id="'cell_' + (forenoonNum*weekDayNum + n*weekDayNum + m-1)"
                                :name="'weekDayNum_' + m"
                                onclick="showDetailInfo(this.id)"></td>
                        </tr>
                    </template>
                    <tr v-if="afternoonNum > 0" :style="{height: timetableRowHeight + 'px'}">
                        <td class="timetableTitle separetor contentHide" :rowspan="afternoonNum">下<br/><br/>午</td>
                        <td class="timetableTitle contentHide">1</td>
                        <td class="timetableTitle contentHide"
                            v-html="timeQuantum[forenoonNum+noonNum]"></td>
                        <td v-for="m in weekDayNum"
                            class="timetableContent"
                            :id="'cell_' + (forenoonNum*weekDayNum + noonNum*weekDayNum + m-1)"
                            :name="'weekDayNum_' + m"
                            onclick="showDetailInfo(this.id)"></td>
                    </tr>
                    <template v-if="afternoonNum > 1">
                        <tr v-for="n in afternoonNum-1" :style="{height: timetableRowHeight + 'px'}">
                            <td :class="n < afternoonNum-1 ? 'timetableTitle contentHide' : 'timetableTitle separetor contentHide'">{{ n+1 }}</td>
                            <td :class="n < afternoonNum-1 ? 'timetableTitle contentHide' : 'timetableTitle separetor contentHide'"
                                v-html="timeQuantum[forenoonNum+noonNum+n]"></td>
                            <td :class="n < afternoonNum-1 ? '' : 'separetor'"
                                v-for="m in weekDayNum"
                                class="timetableContent"
                                :id="'cell_' + (forenoonNum*weekDayNum + noonNum*weekDayNum + n*weekDayNum + m-1)"
                                :name="'weekDayNum_' + m"
                                onclick="showDetailInfo(this.id)"></td>
                        </tr>
                    </template>
                    <tr v-if="eveningNum > 0" :style="{height: timetableRowHeight + 'px'}">
                        <td class="timetableTitle contentHide" :rowspan="eveningNum">晚<br/><br/>上</td>
                        <td class="timetableTitle contentHide">1</td>
                        <td class="timetableTitle contentHide"
                            v-html="timeQuantum[forenoonNum+noonNum+afternoonNum]"></td>
                        <td v-for="m in weekDayNum"
                            class="timetableContent"
                            :id="'cell_' + (forenoonNum*weekDayNum + noonNum*weekDayNum + afternoonNum*weekDayNum + m-1)"
                            :name="'weekDayNum_' + m"
                            onclick="showDetailInfo(this.id)"></td>
                    </tr>
                    <template v-if="eveningNum > 1">
                        <tr v-for="n in eveningNum-1" :style="{height: timetableRowHeight + 'px'}">
                            <td class="timetableTitle contentHide">{{ n+1 }}</td>
                            <td class="timetableTitle contentHide"
                                v-html="timeQuantum[forenoonNum+noonNum+afternoonNum+n]"></td>
                            <td v-for="m in weekDayNum"
                                class="timetableContent"
                                :id="'cell_' + (forenoonNum*weekDayNum + noonNum*weekDayNum + afternoonNum*weekDayNum + n*weekDayNum + m-1)"
                                :name="'weekDayNum_' + m"
                                onclick="showDetailInfo(this.id)"></td>
                        </tr>
                    </template>
                    <thead>
                    <tr>
                        <th class="timetableTitle separetor contentHide" colspan="3">
                            备注
                        </th>
                        <th  :colspan="weekDayNum+3" style="text-align: left;font-size: 14px;border-width: 1px">
                            <span v-html="remark"/>
                        </th>
                    </tr>
                    </thead>
                </table>
            </div>
            <div id="tipsArea">
                点击单元格可查看课程详情
            </div>

            <el-dialog id="detailDialog" class="formDialog" title="详情" :visible.sync="dialogVisible" v-if="dialogVisible" width="90%">
                <el-scrollbar id="detailDialogScroll" ref="detailDialogScroll">
                    <el-form label-width="80px" label-position="left" width="100%">
                        <el-form-item label="上课时间">{{ courseInfo.time }}</el-form-item>
                        <el-form-item label="课程名称">{{ courseInfo.courseName }}</el-form-item>
                        <el-form-item label="课程类型">{{ courseInfo.courseTypeName }}</el-form-item>
                        <el-form-item label="上课班级">{{ courseInfo.className }}</el-form-item>
                        <el-form-item label="授课教师">{{ courseInfo.teaName }}</el-form-item>
                        <el-form-item label="授课场地">{{ courseInfo.siteName }}</el-form-item>
                        <el-form-item label="授课周次">{{ courseInfo.weekNum }}</el-form-item>
                    </el-form>
                </el-scrollbar>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import { confirmMsg, showNotify } from "utils/message";

    export default {
        data() {
            return {
                teaAuthVisible: null,
                stuAuthVisible: null,
                comboOption: {
                    semester: null,
                    week: null,
                },
                queryForm: {
                    semesterCode: null,
                    weekNum: null,
                    userCode: null,
                    showDivideCourse: false,
                },
                curSemesterCode: null,
                curWeekNum: null,
                tableData: [],
                dialogVisible: false,
                timetableRowHeight: 55,
                //课表基本参数
                weekDayNum: null,
                weekDayName: null,
                weekDayDate: null,
                timeName: null,
                forenoonNum: null,
                noonNum: null,
                afternoonNum: null,
                eveningNum: null,
                totalNum: null,
                timeQuantum: [],
                //课表内容
                timetableInfo : null,
                cellContent: [],
                timetableLoading: false,
                singleWeek: false,
                //详情
                courseInfo: {
                    courseName: null,
                    cousseTypeName: null,
                    time: null,
                    className: null,
                    teaName: null,
                    siteName: null,
                    weekNum: null,
                },
                remark:null,
                tempRemark:null,
                userRole:'',
                allowQueryState: false,
            };
        },
        created() {
            this.queryUserInfo();

            window.showDetailInfo = this.showDetailInfo;
        },
        mounted() {
            this.queryCurSemesterInfo();
        },
        methods: {
            queryUserInfo() {
                this.$api.system.basic.userInfo({}).then((res) => {
                    const userInfo = res.data.data;

                    if (userInfo) {
                        let roleInfo = userInfo.roles;

                        for (var roleCode in roleInfo) {
                            // console.log("键：" + roleCode + ",值："+ roleInfo[roleCode]);
                            this.userRole = roleInfo[roleCode];
                        }

                        this.queryForm.userCode = userInfo.phone;

                        if(this.userRole == '学生'){
                            this.stuAuthVisible = true;
                            // this.queryForm.userCode = '20215060010101';
                            // this.queryForm.stuName = userInfo.name;
                            // this.queryForm.stuName = '何睿';
                        }else{
                            this.teaAuthVisible = true;
                            // this.queryForm.userCode = '212036';
                        }
                    } else {
                        this.userRole = '访客';
                        this.$router.push('/login');
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            showHomePage(){
                this.$router.push('/m/wx/home');
            },
            queryCurSemesterInfo(){
                this.$api.timetableManage.common.semesterInfo({
					data: {
						timeType: 'endTime'
					}
                }).then((res) => {
                    this.comboOption.semester = res.data.data.semesterComboData;
                    this.comboOption.week = res.data.data.weekComboData;

                    this.curSemesterCode = res.data.data.curSemesterCode;
                    this.queryForm.semesterCode = res.data.data.curSemesterCode;
                    this.curWeekNum = res.data.data.curSemesterCode;
                    this.queryForm.weekNum = res.data.data.curWeekNum;
                    if(this.queryForm.weekNum){
                        this.singleWeek = true;
                    }
                    this.handleSemesterChange(this.queryForm.semesterCode);
                    this.loadTimetable();
                }).catch((err) => {
                    console.log(err);
                });
            },
            handleSemesterChange(){
                this.allowQueryState = false;
                for (const semesterInfo of this.comboOption.semester) {
                    if(semesterInfo.comboValue == this.queryForm.semesterCode){
                        this.allowQueryState = semesterInfo.otherInfo=='1'?true:false;

                        if(!this.allowQueryState){
                            this.$alert("当前所选学期的课表未开放查询", "提示", {
                                confirmButtonText: "确定",
                                customClass: 'el-message-box-mobile',
                            });
                        }

                        break;
                    }
                }

                this.loadWeekCombo();
            },
            handleWeekChange(){
                if(this.allowQueryState){
                    if(this.queryForm.weekNum != ''){
                        this.singleWeek = true;
                    }else{
                        this.singleWeek = false;
                    }
                    this.loadTimetable();
                }
            },
            loadWeekCombo(){
                this.$api.timetableManage.common.weekCombo({
                    data: this.queryForm
                }).then((res) => {
                    this.comboOption.week = res.data.data.weekComboData;
                    this.curWeekNum = null;
                    this.queryForm.weekNum = null;
                    this.singleWeek = false;

                    this.loadTimetable();
                }).catch((err) => {
                    console.log(err);
                });
            },
            loadTimetable(){
                if(this.allowQueryState){
                    this.timetableLoading = true;
                    this.initBlankTimetable();

                    if(this.teaAuthVisible){
                        this.queryTeaTimetable();
                    }else{
                        this.queryStuTimetable();
                    }
                }else {
                    $('.timetableContent').html('');
                }
            },
            initBlankTimetable(){
                this.$api.timetableManage.common.baseParam({
                    data: this.queryForm
                }).then((res) => {
                    this.weekDayNum = parseInt(res.data.data.baseParam.weekDayNum, 10);
                    this.weekDayName = res.data.data.baseParam.weekDayName.split(',');
                    this.forenoonNum = parseInt(res.data.data.baseParam.forenoonNum, 10);
                    this.noonNum = parseInt(res.data.data.baseParam.noonNum, 10);
                    this.afternoonNum = parseInt(res.data.data.baseParam.afternoonNum, 10);
                    this.eveningNum = parseInt(res.data.data.baseParam.eveningNum, 10);
                    this.totalNum = this.forenoonNum + this.noonNum + this.afternoonNum + this.eveningNum;
                    //处理时间名称
                    this.handleTimeNameInfo();
                    //处理节次时间
                    this.handleOrderNumTimeInfo(res.data.data.baseParam.timeQuantum);
                    //处理课表行高
                    this.handleTimetableRowHeight();
                }).catch((err) => {
                    console.log(err);
                });
            },
            handleTimeNameInfo(){
               this.timeName = new Array();

               for(let i=0; i<this.forenoonNum; i++){
                   // this.timeName.push({
                   //     index: orderNumIndex<10 ? ('0'+orderNumIndex) : orderNumIndex,
                   //     name: '上午' + (i+1)
                   // });
                   this.timeName.push('上午' + (i+1));
               }
               for(let i=0; i<this.noonNum; i++){
                   this.timeName.push('中午' + (i+1));
               }
               for(let i=0; i<this.afternoonNum; i++){
                   this.timeName.push('下午' + (i+1));
               }
               for(let i=0; i<this.eveningNum; i++){
                   this.timeName.push('晚上' + (i+1));
               }
            },
            handleOrderNumTimeInfo(tempTimeQuantum){
                const timeQuantumArray = tempTimeQuantum.split(',');
                const _this = this;
                this.timeQuantum = new Array();
                timeQuantumArray.forEach(element => {
                    _this.timeQuantum.push(element.split('@')[1].replace('~', '<div style="height:10px; font-size:10px;">|</div>'));
                });
            },
            handleTimetableRowHeight(){
                const height = $('#contentArea').height();
                //默认高度55，内容高度低于总高度自动拉伸
                if(this.totalNum * 55 < height - 60){
                    this.timetableRowHeight = (height - 60) / this.totalNum;
                }else{
                    this.timetableRowHeight = 55;
                }
            },
            queryTeaTimetable(){
                this.$api.timetableManage.query.tea({
                    data: {
                        semesterCode: this.queryForm.semesterCode,
                        weekNum: this.queryForm.weekNum,
                        teaCode: this.queryForm.userCode,
                        showDivideCourse: this.queryForm.showDivideCourse,
                    },
                }).then((res) => {
                    this.timetableInfo = res.data.data.timetable.cellList;
                    this.weekDayDate = res.data.data.weekdayDate;
                    this.remark = res.data.data.timetable.remark
                    this.$nextTick(() => {
                        this.parseTimetableInfo(this.timetableInfo);
                        this.handleTimetableShow();
                    });
                }).catch((err) => {
                    this.timetableLoading = false;
                    console.log(err);
                });
            },
            queryStuTimetable(){
                this.timetableLoading = true;

                this.$api.timetableManage.query.stu({
                    data: {
                        semesterCode: this.queryForm.semesterCode,
                        weekNum: this.queryForm.weekNum,
                        stuCode: this.queryForm.userCode,
                        showDivideCourse: this.queryForm.showDivideCourse,
                    },
                }).then((res) => {
                    this.timetableInfo = res.data.data.timetable.cellList;
                    this.weekDayDate = res.data.data.weekdayDate;
                    this.tempRemark = res.data.data.timetable.remark
                    let tempRemark = this.tempRemark;
                    tempRemark = tempRemark.replace('｜｜', '<br/><br/>');
                    this.remark = tempRemark;
                    this.$nextTick(() => {
                        this.parseTimetableInfo(this.timetableInfo);
                        this.handleTimetableShow();
                    });
                }).catch((err) => {
                    this.timetableLoading = false;
                    console.log(err);
                });
            },
            parseTimetableInfo(timetableInfo){
                const _this = this;

                timetableInfo.forEach((cell, index) => {
                    let tempContent = '';

                    //课程名称
                    let tempCourseName = _this.handleTimetableContent(cell.courseName);
                    if(tempCourseName.length > 0){
                        tempContent = tempCourseName;

                        //场地名称
                        let siteName = _this.handleTimetableContent(cell.siteName);
                        if(siteName.length > 0) tempContent += "<br/>" + siteName;

                        //非单周查询显示周次信息
                        if(!this.singleWeek){
                            let weekNum = _this.handleTimetableContent(cell.weekNum);
                            if(weekNum.length > 0) tempContent += "<br/>" + weekNum;
                        }
                    }

                    if (tempContent !== '') {
                        tempContent += '<span style="display:none">'
                        tempContent += cell.className
                        tempContent += cell.courseName
                        tempContent += cell.courseTypeName
                        tempContent += cell.siteName
                        tempContent += cell.teaName
                        tempContent += cell.weekNum
                        tempContent += '</span>'
                    }

                    document.getElementById('cell_' + index).innerHTML = tempContent;
                });
            },
            handleTimetableContent(str){
                const strLenLimit = 8;

                if(str){
                    if(str.length > strLenLimit){
                        str = str.substring(0, strLenLimit-1) + '…';
                    }
                }else{
                    str = '';
                }

                return str;
            },
            handleTimetableShow(){
                this.createTempTimetable();
                this.mergeTimetableCell();
                this.fixTable();
                this.timetableLoading = false;
            },
            //合并课程表单元格
            mergeTimetableCell(){
                let cellArray = $('#tempTimetable .timetableContent');

                for(let i=0; i<this.weekDayNum; i++){
                    //获取当天所有单元格
                    let curDayCellArray = new Array();
                    cellArray.each((index, ele) => {
                        if($(ele).attr('name').substring(11) == (i+1)){
                            curDayCellArray.push(ele);
                        }
                    });

                    for(let j=0; j<curDayCellArray.length; j++){
                        let curCell = $(curDayCellArray[j]);
                        const curContent = curCell.html();
                        let rowNum = 1;
                        let isSeparetor = false;

                        //判断当前单元格内容为空或者为最后单元格，跳过循环
                        if(curContent==='' || j===curDayCellArray.length-1) continue;

                        //判断当前单元格是否可以与下面时间段的课程合并
                        for(let k=j+1; k<curDayCellArray.length; k++){
                            if(curContent === $(curDayCellArray[k]).html()){
                                if($(curDayCellArray[k]).attr('class').indexOf('separetor') > -1){
                                    isSeparetor = true;
                                }else{
                                    isSeparetor = false;
                                }

                                $(curDayCellArray[k]).remove();
                                rowNum++;
                            }else{
                                break;
                            }
                        }

                        //判断是否需要合并
                        if(rowNum > 1){
                            curCell.attr('rowspan', rowNum);
                            if(isSeparetor){
                                curCell.addClass('separetor');
                            }

                            //跳过已被合并的单元格
                            j += (rowNum-1);
                        }
                    }
                }
            },
            //创建临时表
            createTempTimetable(){
                $("#timetable").show();
                const tempTableClone = $("#timetable").clone(true);
                tempTableClone.attr("id", 'tempTimetable');
                $("#timetable").after(tempTableClone);
                $("#timetable").hide();
            },
            //锁定表头和列
            fixTable() {
                const TableID = 'tempTimetable';
                const FixColumnNumber = 3; //要锁定列的个数
                //显示的宽度和高度
                const width = $('#contentArea').width();
                const height = $('#contentArea').height();

                //创建框架
                if ($("#" + TableID + "_tableLayout").length != 0) {
                    $("#" + TableID + "_tableLayout").before($("#" + TableID));
                    $("#" + TableID + "_tableLayout").empty();
                } else {
                    $("#" + TableID).after("<div id='" + TableID + "_tableLayout' style='overflow:hidden; height:" + height + "; width:" + width + ";'></div>");
                }

                $('<div id="' + TableID + '_tableFix"></div>' +
                '<div id="' + TableID + '_tableHead"></div>' +
                '<div id="' + TableID + '_tableColumn"></div>' +
                '<div id="' + TableID + '_tableData"></div>').appendTo("#" + TableID + "_tableLayout");

                const oldtable = $("#" + TableID);
                const tableFixClone = oldtable.clone(true);
                tableFixClone.attr("id", TableID + "_tableFixClone");
                $("#" + TableID + "_tableFix").append(tableFixClone);
                const tableHeadClone = oldtable.clone(true);
                tableHeadClone.attr("id", TableID + "_tableHeadClone");
                $("#" + TableID + "_tableHead").append(tableHeadClone);
                const tableColumnClone = oldtable.clone(true);
                tableColumnClone.attr("id", TableID + "_tableColumnClone");
                $("#" + TableID + "_tableColumn").append(tableColumnClone);
                $("#" + TableID + "_tableData").append(oldtable);
                $("#" + TableID + "_tableLayout table").each(function () {
                    $(this).css("margin", "0");
                });

                //计算tableFix，tableHead的高度
                let HeadHeight = $("#" + TableID + "_tableHead thead").height();
                HeadHeight += 2;
                $("#" + TableID + "_tableHead").css("height", HeadHeight);
                $("#" + TableID + "_tableFix").css("height", HeadHeight);

                //计算tableFix，tableColumn的宽度
                let ColumnsWidth = 0;
                $("#" + TableID + "_tableColumn tr:eq(1) td:lt(" + 3 + ")").each(function () {
                    ColumnsWidth += $(this).outerWidth(true);
                });
                ColumnsWidth += 2;

                $("#" + TableID + "_tableColumn").css("width", ColumnsWidth);
                $("#" + TableID + "_tableFix").css("width", ColumnsWidth);

                //为tableHead和tableColumn添加联动的滚动条事件
                $("#" + TableID + "_tableData").scroll(function () {
                    $("#" + TableID + "_tableHead").scrollLeft($("#" + TableID + "_tableData").scrollLeft());
                    $("#" + TableID + "_tableColumn").scrollTop($("#" + TableID + "_tableData").scrollTop());
                });

                $("#" + TableID + "_tableFix").css({"overflow": "hidden", "position": "relative", "z-index": "50"});
                $("#" + TableID + "_tableHead").css({
                    "overflow": "hidden",
                    "width": width,
                    "position": "relative",
                    "z-index": "45"
                });
                $("#" + TableID + "_tableColumn").css({
                    "overflow": "hidden",
                    "height": height,
                    "position": "relative",
                    "z-index": "40"
                });
                $("#" + TableID + "_tableData").css({
                    "overflow": "auto",
                    "width": width,
                    "height": height,
                    "position": "relative",
                    "z-index": "35"
                });

                //为较小的table修正样式
                if ($("#" + TableID + "_tableHead").width() > $("#" + TableID + "_tableFix table").width()) {
                    $("#" + TableID + "_tableHead").css("width", $("#" + TableID + "_tableFix table").width());
                    $("#" + TableID + "_tableData").css("width", $("#" + TableID + "_tableFix table").width());
                }
                if ($("#" + TableID + "_tableColumn").height() > $("#" + TableID + "_tableColumn table").height()) {
                    $("#" + TableID + "_tableColumn").css("height", $("#" + TableID + "_tableColumn table").height());
                    $("#" + TableID + "_tableData").css("height", $("#" + TableID + "_tableColumn table").height());
                }

                $("#" + TableID + "_tableFix").offset($("#" + TableID + "_tableLayout").offset());
                $("#" + TableID + "_tableHead").offset($("#" + TableID + "_tableLayout").offset());
                $("#" + TableID + "_tableColumn").offset($("#" + TableID + "_tableLayout").offset());
                $("#" + TableID + "_tableData").offset($("#" + TableID + "_tableLayout").offset());

                $('#' + TableID + '_tableData').css('width', width);
                $('#' + TableID + '_tableData').css('height', height);
                $('#tempTimetable_tableData .contentHide').css('color', '#FFFFFF');
                $('#tempTimetable_tableData .contentHide').css('background', '#FFFFFF');
            },
            showDetailInfo(id){
                const cellIndex = id.substring(5);
                if(this.timetableInfo[cellIndex].courseName == null) return;

                this.courseInfo.courseName = this.timetableInfo[cellIndex].courseName;
                this.courseInfo.courseTypeName = this.timetableInfo[cellIndex].courseTypeName;
                this.courseInfo.className = this.timetableInfo[cellIndex].className;
                this.courseInfo.teaName = this.timetableInfo[cellIndex].teaName;
                this.courseInfo.siteName = this.timetableInfo[cellIndex].siteName;
                this.courseInfo.weekNum = this.timetableInfo[cellIndex].weekNum;

                //处理时间信息
                this.courseInfo.time = '';
                //日期
                if(this.singleWeek){
                    this.courseInfo.time = this.weekDayDate[cellIndex%this.weekDayNum] + ' / ';
                }
                //星期几
                this.courseInfo.time += this.weekDayName[cellIndex%this.weekDayNum];
                //时间段
                let finalTimeName = '';
                const timeNameIndex = parseInt(this.timetableInfo[cellIndex].orderNum.substring(2), 10)-1;
                const rowSpanNum = $('#tempTimetable #' + id).attr('rowspan');
                //判断是否为合并单元格
                if(rowSpanNum != undefined){
                    let tempTimeNameArray = new Array();
                    for(let i=0; i<rowSpanNum; i++){
                        tempTimeNameArray.push(this.timeName[timeNameIndex+i]);
                    }

                    //合并时间段
                    let finalTimeNameArray = new Array();
                    for(let i=0; i<tempTimeNameArray.length; i++){
                        let isExist = false;
                        const tempTimeName = tempTimeNameArray[i].substring(0, 2);

                        for(let j=0; j<finalTimeNameArray.length; j++){
                            if(tempTimeName === finalTimeNameArray[j].substring(0, 2)){
                                finalTimeNameArray[j] = finalTimeNameArray[j] + '、' + tempTimeNameArray[i].substring(2);
                                isExist = true;
                            }
                        }
                        if(isExist === false){
                            finalTimeNameArray.push(tempTimeNameArray[i]);
                        }
                    }

                    //拼接最终结果
                    for(let i=0; i<finalTimeNameArray.length; i++){
                        finalTimeName += finalTimeNameArray[i].substring(0, 2) + '第 ' + finalTimeNameArray[i].substring(2) + ' 节，';
                    }
                    finalTimeName = finalTimeName.substring(0, finalTimeName.length-1);
                }else{
                    finalTimeName = this.timeName[timeNameIndex].substring(0, 2) + '第 ' + this.timeName[timeNameIndex].substring(2) + ' 节';
                }
                this.courseInfo.time += ' / ' + finalTimeName;

                this.dialogVisible = true;
            },
            restoreScroll(){
                this.$nextTick(() => {
                    this.$refs.mainDialogScroll.wrap.scrollTop = 0;
                });
            },
            closeDialog() {
                this.dialogVisible = false;
                this.fieldVisible = true;
                this.auditAreaVisible = false;

                if(this.$refs['applyForm'] !== undefined){
                    this.$refs['applyForm'].resetFields();
                }
                this.stuInfo = '';
                this.comboOption.oriCourseInfo = null;
                this.comboOption.newCourseInfo = null;
            },
        }
    };
</script>
<style src="styles/mobile.css"></style>
<style scoped>
    #mobileMode #queryArea {
        height: 50px;
        margin: 20px 0 0 0;
    }

    #mobileMode #tipsArea {
        width: 100vw;
        height: 25px;
        line-height: 25px;
        font-size: 14px;
        color: #0055ff;
        text-align: center;
        display: none;
    }

    #mobileMode #contentArea {
        width: 96%;
        height: calc(100% - 160px);
        margin: 2%;
        border: 1px solid #DCDFE6;
        border-collapse: collapse;
        border-spacing: 0;
        overflow: hidden;
    }

    .timetable {
        border-collapse: collapse;
        border-spacing: 0;
        text-align: center;
        font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
    }

    .timetable tr {
        height: 50px;
    }

    .timetable th {
        line-height: 20px;
        text-align: center;
    }

    .timetable td, .timetable th {
        border-right: 1px solid #DCDFE6;
        border-bottom: 1px solid #DCDFE6;
        padding: 0;
    }

    .timetableTitle {
        background-color: #F1FAF6;
        font-weight: bold;
    }

    .separetor {
        border-bottom: 4px double #DCDFE6 !important;
    }

    .timetableContent {
        width: 195px;
        font-size: 14px;
        word-break: break-all;
    }

    #mobileMode #detailDialog {
        top: 100px;
    }

    #mobileMode #detailDialogScroll {
        max-height: 60vh;
        padding: 10px 20px;
    }
</style>



// WEBPACK FOOTER //
// timetable.vue?419f39eb